import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetch gallery images for a given page section (e.g. "portfolio", "process", "about", "home").
export default function usePhotos(section) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get("/gallery", { params: section ? { section } : {} })
      .then((r) => { if (active) setImages(r.data); })
      .catch(() => { if (active) setImages([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [section]);

  return { images, loading };
}
